(function () {
    'use strict';

    angular
        .module('app.score-detail')
        .component('sc3ScoreDetailHeader', {
            templateUrl: 'app/score-detail/score-detail-header/score-detail-header.component.html',
            controller: ScoreDetailHeaderComponent,
            bindings: { data: '<' }
        });

    ScoreDetailHeaderComponent.$inject = ['$filter'];
    function ScoreDetailHeaderComponent($filter) {
        var ctrl = this,
            isNull = $filter('isnull'),
            formatNumber = $filter('number');

        ctrl.scoreChart = null;
        ctrl.parStatData = null;
        ctrl.$onInit = init;

        function init() {
            ctrl.scoreChart = createScoreChart();
            ctrl.parStatData = createParStatData();
        }

        function createScoreChart() {
            var data = ctrl.data,
                isHoleByHole = data.isHoleByHole,
                gross = data.gross,
                isEmpty = !isHoleByHole || !gross || (data.eagles + data.birdies + data.pars + data.bogeys + data.doubles + data.others == 0);

            if (isEmpty) {
                data.albatross = data.eagles = data.birdies = data.pars = data.bogeys = data.doubles = data.others = null;
            }

            // colors: [ '#FF00FF', '#6495ED', '#008080', '#FFD700', '#FFA500', '#FF0000', '#D9D9D9']
            return {
                labels: ['Eagle', 'Birdie', 'Par', 'Bogey', 'Double', 'Other', 'N/A'],
                data: [data.eagles, data.birdies, data.pars, data.bogeys, data.doubles, data.others, isEmpty ? 1 : 0],
                colors: [
                    "#75b2f0",
                    "#75f0f0",
                    "#75f075",
                    "#f0f075",
                    "#f0b375",
                    "#f07575",
                    "#D9D9D9"
                ],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: { enabled: !isEmpty },
                    hover: { mode: !isEmpty ? 'nearest' : null }
                }
            }
        }
        function createParStatData() {
            var data = ctrl.data;
            return [
                { name: 'Par 3', value: isNull(formatNumber(data.par3, 1), 'N/A') },
                { name: 'Par 4', value: isNull(formatNumber(data.par4, 1), 'N/A') },
                { name: 'Par 5', value: isNull(formatNumber(data.par5, 1), 'N/A') }
            ];
        }
    }
})();